module.exports = __webpack_public_path__ + "img/public/SiteIcons/modalCloseIcon.svg?d0ae1812";